import styled from 'styled-components';
import { BREAK_POINT_MOBILE_MAX } from '@sdk/components/ui/layout/constants';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';

export const Container = styled(Column)`
  height: 100%;
  min-height: 100%;
`;

export const ColumnsContainer = styled(Row)`
  flex: 1;
`;

export const LeftColumn = styled(Column)`
  flex-grow: 1;
  min-width: 258px;
  flex-shrink: 1;

  @media (max-width: ${BREAK_POINT_MOBILE_MAX}px) {
    display: none;
  }
`;

type RightColumnProps = {
  topSpacing?: number;
};
export const RightColumn = styled(Row)<RightColumnProps>`
  padding-top: 20px;
  background-color: ${(props): string => props.theme.colors.white};
  flex-grow: 4.5;
  max-height: calc(100vh - ${(props): number => props.topSpacing || 0}px);
  overflow-y: auto;
  position: relative;
  flex-shrink: 1;
`;

export const StepContent = styled(Row)`
  z-index: 1;
  flex-grow: 1;
  flex-shrink: 1;
`;

export const StepContentPadding = styled(StepContent)`
  max-width: 117px;
  min-width: 20px;
`;

export const OrgSetupContainer = styled.div`
  align-self: flex-end;
  display: flex;
  width: 335px;
`;

export const StyledSideImage = styled.img`
  max-width: 800px;
  margin-top: -120px;
`;
